import { GetBodyCustomerAttachedImagesQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerAttachedImages/getBodyCustomerAttachedImagesQuery.type';
import { getBodyCustomerAttachedImagesQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerAttachedImages/getBodyCustomerAttachedImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyCustomerAttachedImagesQueryOptions = (
  params: GetBodyCustomerAttachedImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getBodyCustomerAttachedImagesQueryOptions', params],
    queryFn: () => getBodyCustomerAttachedImagesQueryFunction(params),
    enabled: true,
  });
};
